import React, { useEffect, useRef } from 'react';
import './Metodologia.css';

// Importamos la pincelada
import brushStroke from '../assets/images/brush-stroke.webp';

// Importamos las imágenes de cada paso
import paso1 from '../assets/images/paso1.webp';
import paso2 from '../assets/images/paso2.webp';
import paso3 from '../assets/images/paso3.webp';
import paso4 from '../assets/images/paso4.webp';
import paso5 from '../assets/images/paso5.webp';

const pasos = [
  {
    id: '01',
    titulo: 'Entrevista personal',
    texto: `Para nosotros es muy importante establecer un primer contacto contigo donde podamos analizar tu situación en detalle. Te preguntaremos por tus antecedentes médicos, tu historial lesivo, tus objetivos y tu disponibilidad horaria con el objetivo de recomendarte los planes que mejor se adapten a tu situación.`,
    imagen: paso1,
  },
  {
    id: '02',
    titulo: 'Valoración',
    texto: `Frase mítica del físico y matemático británico William Thomson Kelvin: “lo que no se mide no se puede mejorar. Lo que no se mejora, se degrada siempre”.\n\nEl primer paso para poder cumplir tus objetivos pasa por realizar una evaluación exhaustiva de las capacidades que sean más relevantes para poder alcanzar tus objetivos. Habitualmente esta fase pasa por realizar mediciones de movilidad articular, fuerza isométrica, pliometría, capacidad aeróbica, perfil de fuerza-velocidad u otras variables que nos permitan analizar tus fortalezas y debilidades.`,
    imagen: paso2,
  },
  {
    id: '03',
    titulo: 'Preparación del plan personalizado',
    texto: `Con toda la información que hemos obtenido en tu entrevista y tu valoración, prepararemos un plan individualizado y personalizado que te permita alcanzar tus objetivos. Este plan involucrará un trabajo combinado de nuestros profesionales con el objetivo de prevenir cualquier tipo de lesión y de optimizar tu rendimiento deportivo. Para nosotros es muy importante asesorarte acerca de tu situación de forma realista para evitar crear falsas expectativas.`,
    imagen: paso3,
  },
  {
    id: '04',
    titulo: 'Seguimiento y contacto',
    texto: `Durante la ejecución de tu plan, realizaremos un seguimiento continuo y cercano de tu situación para poder ayudarte a ajustar la planificación de las cargas y los periodos de recuperación. Estaremos a tu disposición para la realización de informes de situación o para establecer contacto con tu club de origen si fuera necesario.`,
    imagen: paso4,
  },
  {
    id: '05',
    titulo: 'Reevaluación y ajuste',
    texto: `Uno de los principios básicos de nuestra metodología pasa por evaluar de manera periódica con el objetivo de detectar si se están cumpliendo los objetivos fijados y de poder reajustar el plan si no se estuviera siendo del todo efectivo.`,
    imagen: paso5,
  },
];

export default function Metodologia() {
  const pasosRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    pasosRef.current.forEach(el => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="metodologia-simple">
      {/* Título de sección */}
      <h1 className="section-title">
        <div className="title-container">
          <img src={brushStroke} alt="" className="brush-behind-title" />
          <span className="title-text">METODOLOGÍA</span>
        </div>
      </h1>

      {/* Pasos de la metodología */}
      {pasos.map((paso, idx) => (
        <div
          key={paso.id}
          className="paso-simple"
          ref={el => (pasosRef.current[idx] = el)}
          style={{ '--delay': `${0.2 + idx * 0.2}s` }}
        >
          <img
            src={paso.imagen}
            alt={`Paso ${paso.id}`}
            className="paso-img-simple"
          />

          <div className="paso-texto-simple">
            {/* pincelada detrás de cada texto */}
            <img src={brushStroke} alt="" className="brush-behind" />

            <div className="text-content">
              <h2>{paso.titulo}</h2>
              {paso.texto.split('\n\n').map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </div>
        </div>
      ))}
    </section>
  );
}
